export default __webpack_public_path__ + "static/media/abstract05.45e29ae2.webp";